const baseUrl = "https://sisnot.artesp.sp.gov.br";

export const environment = {
  msal: {
    clientId: '09b85dc4-a26e-427d-80d6-28ba7e9ab81a',
    tenantId: '23ce5604-35af-46cc-8f0e-21d715c7f9fb',
    redirectUri: `${baseUrl}/auth/redirect-callback`,
    issuer: 'https://authorization.artesp.sp.gov.br',
    requireHttps: false,
  },
  api: {
    uri: `https://sisnot.artesp.sp.gov.br/api/sisnot-admin/`
  },
  version: '1.2.1',
  name: 'Sisnot'
}
